<!--TODO: remove later; component has no business value and needed for demonstration purposes only-->
<div [formGroup]="form" class="tw-flex tw-flex-wrap -tw-mx-4">
  <bosch-ui-input
    formControlName="firstName"
    [label]="'First name'"
    [placeholder]="'John'"
    class="tw-w-1/2 tw-py-6 tw-px-4"
  ></bosch-ui-input>
  <bosch-ui-input
    formControlName="lastName"
    [label]="'Last name'"
    [placeholder]="'Doe'"
    class="tw-w-1/2 tw-py-6 tw-px-4"
  ></bosch-ui-input>
  <bosch-ui-input-datetime
    formControlName="date"
    [label]="'Date of birth'"
    class="tw-w-1/2 tw-py-6 tw-px-4"
  ></bosch-ui-input-datetime>
  <bosch-ui-input formControlName="address" [label]="'Address'" class="tw-w-1/2 tw-py-6 tw-px-4"></bosch-ui-input>
</div>
